import { DSChartColors } from 'types/colors.ts'
import { GetMarketPriceBarColor, MarketPriceBarColor } from 'components/charts/market-prices/types.ts'

/**
 * Returns the color of the bar of the given period, which its legend indicator follows. The lowest price highlight
 * takes priority over the running period, and both have a darker shade while hovered
 *
 * @param {GetMarketPriceBarColor} params
 * @returns {MarketPriceBarColor}
 */
export const getMarketPriceBarColor = ({
  index,
  lowestIndexes,
  currentIndex,
  isProducer,
  isHovered
}: GetMarketPriceBarColor): MarketPriceBarColor => {
  const isCurrent = currentIndex >= 0 && index === currentIndex

  if (!isProducer && lowestIndexes.includes(index)) {
    if (isHovered) return DSChartColors.GREEN_HOVER

    return isCurrent ? DSChartColors.GREEN_ACTIVE : DSChartColors.GREEN
  }

  if (isHovered) return DSChartColors.DARK

  return isCurrent ? DSChartColors.GREY_ACTIVE : DSChartColors.GREY
}
